import ContractsPage, {
	HealthDeclarationPage,
	MembershipCreatePage,
	MembershipQuitPage,
	MembershipSuspensionPage,
	MembershipTransferInPage,
	MembershipTransferOutPage,
	MembershipTransferOverPage,
} from "@icoach/documents";
import { CLUB_DOCUMENTS_ROUTER, DOCUMENT_HEALTHY_CYCLE_PURCHASE_ROUTER } from "@icoach/router/routerPath";

// 健康循環訂購
import CyclePurchasePage from "@icoach/healthyCyclePurchase/CyclePurchasePage";
import CyclePurchaseSuspendPage from "@icoach/healthyCyclePurchase/CyclePurchaseSuspendPage";
import CyclePurchaseTerminatePage from "@icoach/healthyCyclePurchase/CyclePurchaseTerminatePage";
import CyclePurchaseResumePage from "@icoach/healthyCyclePurchase/CyclePurchaseResumePage";
import CyclePurchaseChangePage from "@icoach/healthyCyclePurchase/CyclePurchaseChangePage";
import CyclePurchaseOverviewPage from "@icoach/healthyCyclePurchase/CyclePurchaseOverviewPage";
import CyclePurchaseDetailPage from "@icoach/healthyCyclePurchase/CyclePurchaseDetailPage";

// 文書管理
const contractsRouter = [
	{
		description: "合約書頁面",
		exact: true,
		path: CLUB_DOCUMENTS_ROUTER.BASE,
		href: CLUB_DOCUMENTS_ROUTER.BASE,
		as: ContractsPage,
		frontKey: "C4X01",
	},
	{
		description: "入會申請書",
		static: true,
		path: CLUB_DOCUMENTS_ROUTER.MEMBERSHIP.PAGE,
		as: MembershipCreatePage,
		frontKey: "C4X02",
	},
	{
		description: "健康狀況申告書",
		exact: true,
		path: CLUB_DOCUMENTS_ROUTER.HEALTHDECLARATION.PAGE,
		as: HealthDeclarationPage,
		frontKey: "C4X03",
	},
	{
		description: "會籍轉讓申請書",
		exact: true,
		path: CLUB_DOCUMENTS_ROUTER.TRANSFEROVER.PAGE,
		as: MembershipTransferOverPage,
		frontKey: "C4X12",
	},
	{
		description: "國內移籍申請書(移出)",
		exact: true,
		path: CLUB_DOCUMENTS_ROUTER.TRANSFEROUT.PAGE,
		as: MembershipTransferOutPage,
		frontKey: "C4X06",
	},
	{
		description: "國內移籍申請書(移入)",
		static: true,
		path: CLUB_DOCUMENTS_ROUTER.TRANSFERIN.PAGE,
		as: MembershipTransferInPage,
		frontKey: "C4X07",
	},
	{
		description: "會籍暫停申請書",
		exact: true,
		path: CLUB_DOCUMENTS_ROUTER.SUSPENSION.PAGE,
		as: MembershipSuspensionPage,
		frontKey: "C4X04",
	},
	{
		description: "會籍終止申請書",
		exact: true,
		path: CLUB_DOCUMENTS_ROUTER.QUIT.PAGE,
		as: MembershipQuitPage,
		frontKey: "C4X05",
	},
	{
		description: "訂閱HC循環訂購單",
		exact: true,
		path: DOCUMENT_HEALTHY_CYCLE_PURCHASE_ROUTER.CREATE,
		as: CyclePurchasePage,
		frontKey: "C4X10",
	},
	{
		description: "查看HC循環訂購單",
		exact: true,
		path: DOCUMENT_HEALTHY_CYCLE_PURCHASE_ROUTER.DETAIL.PAGE,
		as: CyclePurchaseDetailPage,
		frontKey: "C4X13",
	},
	{
		description: "HC循環邊更單-訂單變更（前端拆頁）",
		exact: true,
		path: DOCUMENT_HEALTHY_CYCLE_PURCHASE_ROUTER.CHANGE.BASE,
		as: CyclePurchaseChangePage,
		frontKey: "C4X10",
	},
	{
		description: "HC循環邊更單-訂單暫停（前端拆頁）",
		exact: true,
		path: DOCUMENT_HEALTHY_CYCLE_PURCHASE_ROUTER.SUSPEND.BASE,
		as: CyclePurchaseSuspendPage,
		frontKey: "C4X10",
	},
	{
		description: "HC循環邊更單-訂單退訂（前端拆頁）",
		exact: true,
		path: DOCUMENT_HEALTHY_CYCLE_PURCHASE_ROUTER.TERMINATE.BASE,
		as: CyclePurchaseTerminatePage,
		frontKey: "C4X10",
	},
	{
		description: "HC循環邊更單-訂單恢復（前端拆頁）",
		exact: true,
		path: DOCUMENT_HEALTHY_CYCLE_PURCHASE_ROUTER.RESUME.BASE,
		as: CyclePurchaseResumePage,
		frontKey: "C4X10",
	},
	{
		description: "HC循環訂單總覽",
		exact: true,
		path: DOCUMENT_HEALTHY_CYCLE_PURCHASE_ROUTER.BASE,
		as: CyclePurchaseOverviewPage,
		frontKey: "C4X11",
	},
];

export default contractsRouter;
